import { useInfiniteQuery } from "@tanstack/react-query";

import { ChatsApi } from "@/api/chats";
import { QueryKey } from "@/utils";

const PER_PAGE = 30;

const useGetActiveSupportChats = () => {
  const { data, isPending, error, fetchNextPage } = useInfiniteQuery({
    queryKey: [QueryKey.ACTIVE_SUPPORT_CHATS],
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      ChatsApi.getActiveSupportChats({
        perPage: PER_PAGE,
        cursor: pageParam,
      }),
    refetchInterval: 30000,
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.meta.nextCursor,
    select: ({ pages }) => {
      const data = pages.flatMap(({ data }) => data);
      const meta = pages[0].meta;

      return { meta, data };
    },
  });

  return {
    activeSupportChats: data,
    activeSupportChatsError: error,
    isActiveSupportChatsLoading: isPending,
    fetchNextActiveSupportChatsPage: fetchNextPage,
  };
};

export { useGetActiveSupportChats };
